module.exports = __webpack_public_path__ + "img/3..aa11b516.jpg";